import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {ProductIntroConfig, ProductIntro} from "./product_intro"

export const productIntroLoader = function (options = {}) {
    componentLoader(componentConfig(ProductIntro, ProductIntroConfig.componentTypeKey, ProductIntroConfig.baseHtmlClass), options);
};

